/**
 *
 * @file token刷新逻辑
 * @author author-name(lhb 1301465186@qq.com)
 */
import Vue from 'vue'
import store from '@/store'
import {
  getExpires,
  getRefresh,
  getAuthTime
} from '@/utils/authStore'
import {
  hasValidAccessToken
} from '@/utils/refreshService'
const offsetSeconds = 90;
Vue.prototype.$offsetSeconds = offsetSeconds;
if (hasValidAccessToken()) {
  store.dispatch('RefreshToken').then(() => {
    if (getRefresh()) {
      if (getExpires() && getAuthTime()) {
        const delay = (Number(getExpires().set_expires_in) - getAuthTime() - offsetSeconds * 1000);
        // const delay = 1000
        setInterval(() => {
          store.dispatch('RefreshToken')
        }, delay > 0 ? delay : 36000000);
      } else {
        setInterval(() => {
          store.dispatch('RefreshToken')
        }, 36000000);
      }
    }
  })
}
